import type * as appointments from '@seen/core/models/appointments/index'
import type { Participant } from '@seen/core/models/patients/participant'
import { Button } from '@seen/ui'
import { IconDoorEnter } from '@tabler/icons-react'
import type { JSX } from 'react'
import { useModalStore } from '#src/hooks/useModalStore.ts'

interface CheckInButtonProps {
  participant: Participant
  isDisabled?: boolean
  appointment?: appointments.ExtendedAppointment
}

export function CheckInButton({
  participant,
  isDisabled = false,
  appointment,
}: CheckInButtonProps): JSX.Element {
  const setCheckInOpen = useModalStore((state) => state.setCheckInOpen)
  const setParticipant = useModalStore((state) => state.setParticipant)
  const setAppointment = useModalStore((state) => state.setAppointment)

  const handleClick = (e: React.MouseEvent): void => {
    e.stopPropagation()
    e.preventDefault()
    setParticipant(participant)
    setAppointment(appointment ?? null)
    setCheckInOpen(true)
  }

  return (
    <Button
      size="icon"
      variant="ghost"
      onClick={handleClick}
      title="Check In"
      disabled={isDisabled}
    >
      <IconDoorEnter />
    </Button>
  )
}
